import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TipoUsuario } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { ISeguridadUsuarioResultadoBusquedaModel } from 'src/app/models/interfaces/seguridad/ISeguridadUsuarioResultadoBusquedaModel';
import { IFilterSolicitudModel } from 'src/app/models/interfaces/solicitud/IFilterSolicitudModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private configContratistaUrl = [environment.apiSecurityContratistaUrl, 'usuarios'].join('/');
  private configEmpleadoUrl = [environment.apiSecurityEmpleadoUrl, 'usuarios'].join('/');
  
  constructor(
    private http: HttpClient
  ) { }

  getList(
    model: IFilterUsuarioModel, 
  ): Observable<SearchResultModel<ISeguridadUsuarioResultadoBusquedaModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if(model.idUsuarios.length > 0){
      queryParams.push(`ids=${model.idUsuarios.join(',')}`);
    }

    if (model.usuario !== '') {
      queryParams.push(`usuario=${model.usuario}`);
    }

    if (model.correo !== '') {
      queryParams.push(`correo=${model.correo}`);
    }
    
    if(model.idTipoUsuario === TipoUsuario.Contratista){
      return this.http.get<SearchResultModel<ISeguridadUsuarioResultadoBusquedaModel[]>>(
        this.configContratistaUrl + '?'+ queryParams.join('&')
      );
    }
    else{
      return this.http.get<SearchResultModel<ISeguridadUsuarioResultadoBusquedaModel[]>>(
        this.configEmpleadoUrl + '?'+ queryParams.join('&')
      );
    }
  }
}
